import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("app-window", {
    attrs: { value: _vm.dialog, actions: "" },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              VForm,
              {
                ref: "form",
                model: {
                  value: _vm.valid,
                  callback: function ($$v) {
                    _vm.valid = $$v
                  },
                  expression: "valid",
                },
              },
              [
                _c(VRow, { staticClass: "mx-2" }, [
                  _c("h4", { staticClass: "title secondary--text" }, [
                    _vm._v(" Histórico de Alterações da Responsabilidade "),
                  ]),
                ]),
                _c(
                  VRow,
                  [
                    _c(
                      VCol,
                      { attrs: { cols: "12" } },
                      [
                        _c("historico-responsabilidade-list", {
                          attrs: {
                            responsabilidade: _vm.responsabilidadeHistorico,
                            etapa: _vm.etapa,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  VRow,
                  { staticClass: "mx-2" },
                  [
                    _c("h4", { staticClass: "title secondary--text mr-4" }, [
                      _vm._v(" Formulário de Alteração da Responsabilidade "),
                    ]),
                    !_vm.isEditada
                      ? _c(
                          VChip,
                          {
                            staticClass: "mr-4",
                            attrs: {
                              color: "success",
                              outlined: "",
                              small: "",
                            },
                          },
                          [_vm._v(" Nenhuma alteração realizada ")]
                        )
                      : _c(
                          VChip,
                          {
                            staticClass: "mr-4",
                            attrs: {
                              color: "warning",
                              outlined: "",
                              small: "",
                            },
                          },
                          [_vm._v(" Alterações pendentes ")]
                        ),
                  ],
                  1
                ),
                _c(
                  VRow,
                  { staticClass: "mx-2" },
                  [
                    _c(
                      VCol,
                      { attrs: { cols: "12" } },
                      [
                        _c(VTextField, {
                          attrs: {
                            id: "titulo",
                            rules: _vm.rules.titulo,
                            color: "primary",
                            label: "Responsabilidade",
                            "prepend-icon": "done",
                            required: "",
                            tabindex: "1",
                          },
                          model: {
                            value: _vm.responsabilidadeAux.titulo,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.responsabilidadeAux,
                                "titulo",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "responsabilidadeAux.titulo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c(VSelect, {
                          staticClass: "mr-4",
                          attrs: {
                            items: _vm.dificuldades,
                            rules: _vm.rules.dificuldade,
                            color: "primary",
                            "item-text": "descricao",
                            label: "Nível de Dificuldade",
                            "prepend-icon": "how_to_reg",
                            required: "",
                            tabindex: "2",
                            "return-object": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item",
                              fn: function (data) {
                                return [
                                  _c(
                                    VListItemContent,
                                    [
                                      _c(VListItemTitle, [
                                        _vm._v(
                                          " " +
                                            _vm._s(data.item.descricao) +
                                            " "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.responsabilidadeAux.dificuldade,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.responsabilidadeAux,
                                "dificuldade",
                                $$v
                              )
                            },
                            expression: "responsabilidadeAux.dificuldade",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c(VSelect, {
                          attrs: {
                            items: _vm.impactos,
                            rules: _vm.rules.impacto,
                            color: "primary",
                            "item-text": "descricao",
                            label: "Nível de Impacto",
                            "prepend-icon": "warning",
                            required: "",
                            tabindex: "3",
                            "return-object": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item",
                              fn: function (data) {
                                return [
                                  _c(
                                    VListItemContent,
                                    [
                                      _c(VListItemTitle, [
                                        _vm._v(
                                          " " +
                                            _vm._s(data.item.descricao) +
                                            " "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.responsabilidadeAux.impacto,
                            callback: function ($$v) {
                              _vm.$set(_vm.responsabilidadeAux, "impacto", $$v)
                            },
                            expression: "responsabilidadeAux.impacto",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "8" } },
                      [
                        _c(VAutocomplete, {
                          staticClass: "mr-4",
                          attrs: {
                            items: _vm.competencias,
                            rules: _vm.rules.competencias,
                            "search-input": _vm.search,
                            chips: "",
                            color: "primary",
                            "deletable-chips": "",
                            "item-text": "nomeAtual",
                            label: "Competências técnicas",
                            placeholder: "Digite para pesquisar...",
                            multiple: "",
                            "no-results-text": "Nenhum resultado encontrado.",
                            "prepend-icon": "build",
                            required: "",
                            "return-object": "",
                            tabindex: "4",
                          },
                          on: {
                            "update:searchInput": function ($event) {
                              _vm.search = $event
                            },
                            "update:search-input": function ($event) {
                              _vm.search = $event
                            },
                            change: function ($event) {
                              _vm.search = ""
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _c(
                                    VChip,
                                    {
                                      staticClass: "chip--select-multi",
                                      attrs: {
                                        color:
                                          data.item.unidades.length === 0
                                            ? "secondary"
                                            : "grey",
                                        "input-value": data.selected,
                                        close: "",
                                        "text-color": "white",
                                      },
                                      on: {
                                        "click:close": function ($event) {
                                          return _vm.removeCompetencia(
                                            data.item
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(data.item.nomeAtual) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "no-data",
                              fn: function () {
                                return [
                                  _c(
                                    VListItem,
                                    [
                                      _c(
                                        VListItemContent,
                                        [
                                          _c(VListItemTitle, [
                                            _vm._v(
                                              " Nenhum resultado encontrado para "
                                            ),
                                            _c("strong", [
                                              _vm._v(_vm._s(_vm.search)),
                                            ]),
                                            _vm._v(
                                              ". Para adicionar uma nova competência, "
                                            ),
                                            _c("kbd", [_vm._v("clique")]),
                                            _vm._v(" no botão ao lado. "),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.responsabilidadeAux.competenciasTecnicas,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.responsabilidadeAux,
                                "competenciasTecnicas",
                                $$v
                              )
                            },
                            expression:
                              "responsabilidadeAux.competenciasTecnicas",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      [
                        _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      VBtn,
                                      _vm._g(
                                        {
                                          staticClass: "mt-4",
                                          attrs: {
                                            color: "primary",
                                            dark: "",
                                            text: "",
                                          },
                                          on: {
                                            click:
                                              _vm.toogleCadastroCompetencia,
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _vm._v(" Adicionar "),
                                        _c(VIcon, { staticClass: "ml-2" }, [
                                          _vm._v(" add_circle "),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          },
                          [
                            _c("span", [
                              _vm._v("Clique para adicionar uma competência"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(VSpacer),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("cadastro-edicao-competencia", {
              attrs: {
                competencia: _vm.competencia,
                etapa: _vm.etapa,
                "is-edicao": false,
                mapeamento: _vm.mapeamento,
                toogle: _vm.toogleCadastroCompetencia,
                "unidades-selecionadas": _vm.unidadesSelecionadas,
                visibilidade: _vm.dialogCompetencia,
              },
              on: {
                hide: _vm.toogleCadastroCompetencia,
                return: (value) => _vm.addCompetencia(value),
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c(
              VTooltip,
              {
                attrs: { top: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function ({ on }) {
                      return [
                        _c(
                          VBtn,
                          _vm._g(
                            {
                              staticClass: "mr-2",
                              attrs: {
                                disabled: !_vm.valid || !_vm.isEditada,
                                color: "primary",
                                tabindex: "7",
                              },
                              on: { click: _vm.editar },
                            },
                            on
                          ),
                          [_vm._v(" Salvar ")]
                        ),
                      ]
                    },
                  },
                ]),
              },
              [
                _c("span", [
                  _vm._v("Clique no botão para editar a responsabilidade"),
                ]),
              ]
            ),
            _c(
              VTooltip,
              {
                attrs: { top: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function ({ on }) {
                      return [
                        _c(
                          VBtn,
                          _vm._g(
                            {
                              attrs: {
                                disabled: !_vm.isEditada,
                                color: "primary",
                                outlined: "",
                                tabindex: "7",
                              },
                              on: { click: _vm.assignResponsabilidade },
                            },
                            on
                          ),
                          [_vm._v(" Restaurar ")]
                        ),
                      ]
                    },
                  },
                ]),
              },
              [
                _c("span", [
                  _vm._v("Clique no botão para restaurar a responsabilidade"),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }